import { render, staticRenderFns } from "./reservationRecord.vue?vue&type=template&id=0cb5e8b2&scoped=true&"
import script from "./reservationRecord.vue?vue&type=script&lang=js&"
export * from "./reservationRecord.vue?vue&type=script&lang=js&"
import style0 from "./reservationRecord.vue?vue&type=style&index=0&id=0cb5e8b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb5e8b2",
  null
  
)

export default component.exports